import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {};

const propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default function TestimonialSlideButton({
  label,
  className,
  onClick,
  children,
}) {
  return (
    <div className={clsx('z-20 absolute bottom-0 top-0 flex items-center', className)}>
      <button onClick={onClick} className="bg-white shadow w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-full transition ease-in-out duration-300 focus:outline-none hover:shadow-lg transform hover:-translate-y-1 hover:text-gray-400" type="button">
        {children}
        <div className="sr-only">
          {label}
        </div>
      </button>
    </div>
  );
}

TestimonialSlideButton.defaultProps = defaultProps;
TestimonialSlideButton.propTypes = propTypes;
